// extracted by mini-css-extract-plugin
export default {"uiPlayground":"uiPlayground-BJbbY","title":"title-Sos_9","tabPanel":"tabPanel-oEsyr","tabs":"tabs-MyOiK"};